module.exports = __webpack_public_path__ + "static/hero-6-718dfc8671eea76a98e7be2c727293b8.jpg";